import { WifiOff } from 'lucide-react';
import { useOnline } from '../hooks/useOnline';

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-center text-sm font-medium text-white shadow"
    >
      <WifiOff className="h-4 w-4" aria-hidden="true" />
      <span>You're offline. Changes may not be saved until the connection is restored.</span>
    </div>
  );
}
